import { useAuth } from "@k3-tech/react-kit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/example/see-permissions")({
	component: RouteComponent,
});

function RouteComponent() {
	const auth = useAuth();

	return <pre className="w-[768px] whitespace-break-spaces break-words overflow-hidden">{JSON.stringify(auth.permissions.join(","))}</pre>;
}
